import { render } from "./Search.vue?vue&type=template&id=aa0552e4&scoped=true"
import script from "./Search.vue?vue&type=script&lang=js"
export * from "./Search.vue?vue&type=script&lang=js"

import "./Search.vue?vue&type=style&index=0&id=aa0552e4&lang=scss&scoped=true"

import exportComponent from "/var/www/fgg-staff/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa0552e4"]])

export default __exports__